/** Whom the organisation's file is about. genesis keeps one record per subject and refuses a mixed one. */
export type OrganizationalRecordSubjectKind = "person" | "company";

export type OrganizationalRecordSubject = { kind: OrganizationalRecordSubjectKind; id: string };

/** Exactly one of the two ids travels, which is what genesis validates on the query and the mutation alike. */
export function organizationalRecordSubjectVariables(subject: OrganizationalRecordSubject): { personId?: string; companyId?: string } {
  return subject.kind === "company" ? { companyId: subject.id } : { personId: subject.id };
}
